<template>
  <ol class="breadcrumb" :class="isDark ? 'bg-dark text-light border-0 mb-2 py-2 px-3' : ''">
    <li class="breadcrumb-item" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
      <router-link :to="item" v-else>{{ showName(item) }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    }
  },
  mounted() {
  },
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK'] 
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue